import { ProductCasePack } from "@deliverr/inbound-client/lib/legacy-copy-pasta/product";

export const getCasePackDimsDescription = (productCasePack: ProductCasePack) =>
  `${productCasePack.height} x ${productCasePack.width} x ${productCasePack.length} ${productCasePack.lengthUnit} · ${productCasePack.weight} ${productCasePack.weightUnit}`;
